// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuetify from 'vuetify'
import Vuelidate from 'vuelidate'
import VueTheMask from 'vue-the-mask'

import moment from 'moment'
import store from '@/vuex/store.js'
import router from '@/router'
import VueGtag from 'vue-gtag'

import App from '@/app'

moment.locale('pt-br')
Vue.prototype.moment = moment

Vue.use(Vuetify)
Vue.use(Vuelidate)

Vue.use(VueTheMask)

Vue.use(VueGtag, {
  config: {
    id: 'G-0FTQYC6381'
  }
}, router)

require('@/../node_modules/vuetify/dist/vuetify.min.css')
require('@/../node_modules/animate.css/animate.min.css')
require('@/../node_modules/font-awesome/css/font-awesome.min.css')

/* eslint-disable no-new */
new Vue({
  router,
  store,
  el: '#app',
  template: '<app/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js